'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _inputNumber = require('antd/lib/input-number');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _wrapField = require('./wrapField');

var _wrapField2 = _interopRequireDefault(_wrapField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noneIfNaN = function noneIfNaN(x) {
    return isNaN(x) ? undefined : x;
};

var Num = function Num(props) {
    return (0, _wrapField2.default)(props, _react2.default.createElement(_inputNumber2.default, (0, _extends3.default)({
        disabled: props.disabled,
        id: props.id,
        max: props.max,
        min: props.min,
        name: props.name,
        onChange: function onChange(value) {
            return props.onChange(noneIfNaN(value));
        },
        placeholder: props.placeholder,
        ref: props.inputRef,
        step: props.step || (props.decimal ? 0.01 : 1),
        value: props.value,
        style: { width: '100%' }
    }, (0, _filterDOMProps2.default)(props))));
};

exports.default = (0, _connectField2.default)(Num, { ensureValue: false });


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-antd/NumField.js
// module id = 287
// module chunks = 35783957827783 65974612472484